import { createSelector } from "reselect";

import Store from "../../../../../../../../../../redux/store";

import * as actions from "./flyer-detail-page-form-position-categories.actions";

import { FlyerDetailPageFormPositionState } from "../../types/flyer-detail-page-form-position-state/flyer-detail-page-form-position-state.interface";
import { PositionCategoriesState } from "../../types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.interface";

import { getFlyerDetailPageFormPositionState } from "../flyer-detail-page-form-position.store";

export const getPositionCategoryState = createSelector(
  getFlyerDetailPageFormPositionState,
  (state?: FlyerDetailPageFormPositionState) => state?.categoryState
);

export const getCategories = createSelector(
  getPositionCategoryState,
  (state?: PositionCategoriesState) => state?.categories
);

export function searchCategories(searchText: string) {
  Store.dispatch(actions.searchCategory(searchText));
}

export function clearCategoriesResults() {
  Store.dispatch(actions.clearCategoryResults());
}
